(function() {
    'use strict';
    angular.module('elogbooks.admin.core-clients', ['elogbooks.common.billing-settings']);
})();
